import React from 'react';
import './App.css';
     
const App = () => {
  /*
  const chaosImageSrc =
    "https://web.archive.org/web/20091026061505if_/http://geocities.com/Lelee_1978/wedding/Wedwelcome.gif";
  const chaosImages = Array.from({ length: 100 }, (_, i) => (
    <ChaosImage key={i} src={chaosImageSrc} />
  ));*/

  return (
    <div className="app">
      <img
        src="https://web.archive.org/web/20090902174513if_/http://geocities.com/tygeress_92/The_Wedding_21186.gif"
        className="title"
        alt="wedding title"
      />
      <img
        src="https://web.archive.org/web/20091027075449/http://geocities.com/marriage3/firewall.gif"
        className="subtitle"
        alt="subtitle"
      />
      <img
        src="https://web.archive.org/web/20091026235635/http://www.geocities.com/biandmen/LOVE_ONLINE_06658.gif"
        className="love-online"
        alt="love online"
      />
      <img
        src="https://web.archive.org/web/20090830195000if_/http://www.geocities.com/RodeoDrive/4338/wedding.gif"
        className="centerpiece"
        alt="centerpiece"
      />
      <img
        src="https://web.archive.org/web/20090803143451if_/http://www.geocities.com/ladylorislounge/wedding-031.gif"
        className="side-left"
        alt="side left"
      />
      <img
        src="https://web.archive.org/web/20090803143451if_/http://www.geocities.com/ladylorislounge/wedding-031.gif"
        className="side-right"
        alt="side right"
      />
      <img
        src="https://web.archive.org/web/20091027024433/http://www.geocities.com/braveheartbullmastiffs/ScrollDownText4.gif"
        className="scroll-down"
        alt="scroll down"
      />
      {/*{chaosImages}*/}
      <div className="content-section">
        <h1 className="message">
          we are excited to host you on our big day as we exercise our
        </h1>
        <img
          src="https://web.archive.org/web/20090808102053/http://www.geocities.com/freedomofwillbiz/CROSSBANNER.gif"
          className="cross-banner"
          alt="cross banner"
        />
      </div>
    </div>
  );
};

export default App;